/* global Event */

import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  static targets = ['container', 'content']
  static values = {
    opened: Boolean,
    loading: Boolean
  }

  close () {
    this.hideModal()
    this.emptyModalContents()
  }

  showModal () {
    this.showLoadingSpinner()
    this.openedValue = true
  }

  hideModal () {
    this.hideLoadingSpinner()
    this.openedValue = false
    // This allows other components to "listen" for when the modal is closed.
    // We use this for (e.g.) updating the #hash link when a license page modal is closed.
    window.dispatchEvent(new Event('modalClosed'))
  }

  showLoadingSpinner () {
    this.loadingValue = true
  }

  hideLoadingSpinner () {
    this.loadingValue = false
  }

  emptyModalContents () {
    this.setContentHtml('')
  }

  setContentHtml (html) {
    this.hideLoadingSpinner()
    this.contentTarget.innerHTML = html
  }

  setContentNode (node) {
    this.hideLoadingSpinner()
    this.emptyModalContents()
    this.contentTarget.appendChild(node)
  }
}
